import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class DynamicFormConfig extends CloudObject {}

// Hardcoded tags
register('018f2ece64a615790576', DynamicFormConfig);
DynamicFormConfig.nameProp = defineProperty('018f2ece8c8c3d5c0e87');
DynamicFormConfig.propertyProp = defineProperty('018f2eceb8c6adc2c986');
DynamicFormConfig.typeProp = defineProperty('018f2ed37100bee0443c');
DynamicFormConfig.rangeProp = defineProperty('018f331c63c67fff0790');
DynamicFormConfig.regexProp = defineProperty('018f33215330d9e231c5');
DynamicFormConfig.rankProp = defineProperty('018f383b7929c2e54664');
